import React from 'react';
import ReactDOM from 'react-dom';
import {TrackDispatcher} from '../../../../hooks/useTracks';
import WritableTrackPopup from './WritableTrackPopup';
import NonWritableTrackPopup from './NonWritableTrackPopup';

export interface TrackPopupProps {
    trackLocalId: string;
    tracks: Record<string, Track>;
    trackDispatcher: TrackDispatcher;
    onTrackMoveStart: (trackLocalId: string, mapboxLayerId: string | undefined) => void;
    onPopupChange: (popup: MapPopup) => void;
    project: MapProject;
    interaction: MapInteraction;
    mapboxLayerId: string | undefined;
}

export default function TrackPopup(props: TrackPopupProps) {
    const {tracks, trackLocalId} = props;
    const track = tracks[trackLocalId];

    if (track.properties.writable) {
        return <WritableTrackPopup {...props} />;
    } else {
        return <NonWritableTrackPopup {...props} />;
    }
}
